export enum AppEnum {
  CleanAppData = 'cleanAppData',
  SetAccessTokenData = 'setAccessTokenData',
  SetRefreshTokenData = 'setRefreshTokenData',
  InitRefreshTokens = 'initRefreshTokens',
  FailRefreshTokens = 'failRefreshTokens',
  CleanAppAlerts = 'CleanAppAlerts',
  FinishAuthorization = 'FinishAuthorization',
  SetContactFormVisibility = 'SetContactFormVisibility',
}
